import { render, staticRenderFns } from "./AddBankDetails.vue?vue&type=template&id=03e72d39"
import script from "./AddBankDetails.vue?vue&type=script&lang=js"
export * from "./AddBankDetails.vue?vue&type=script&lang=js"
import style0 from "./AddBankDetails.vue?vue&type=style&index=0&id=03e72d39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports